import { Label } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { mediaQuery } from 'lib/styledSystem';

const FilterLabel = styled(Label)`
  line-height: 1.3;
  padding: ${themeGet('space.3')};
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};
  margin: 0;
  font-size: ${themeGet('fontSizes.base')};

  ${(props) =>
    props.isChecked &&
    css`
      background: ${themeGet('colors.ui.infoBackground')(props)};
      font-weight: ${themeGet('fontWeights.bold')(props)};
    `};

  ${mediaQuery.minWidth.md} {
    margin: 0;
    font-weight: normal;
    padding-bottom: 0;
    border-bottom: none;
    padding-left: 0;

    &:last-child {
      margin-bottom: ${themeGet('space.1')};
    }

    ${(props) =>
      props.isChecked &&
      css`
        background: none;
        font-weight: normal;
      `};
  }
`;

FilterLabel.displayName = 'FilterLabel';

export default FilterLabel;
